import React, { useState } from 'react';
import PropType from 'prop-types';
import { Link } from 'react-router-dom';
import { Provider } from 'react-redux';
import StatusBadge from '../../shared/components/StatusBadge/StatusBadge';
import Accordion from '../../shared/components/Accordion/Accordion';
import IconEdit from '../../shared/icons/icon-edit.svg';
import IconTrash from '../../shared/icons/icon-trash.svg';
import Modal from '../../shared/components/Modal/Modal';
import IconPercent from '../../shared/icons/icon-percent.svg';
import IconDownload from '../../shared/icons/icon-download.svg';
import GenerateCodes from './GenerateCodes';
import CreateResource from '../../CreateEditResource/CreateResource';
import Tooltip from '../../shared/components/Tooltip/Tooltip';
import { FORM_OPERATION_READ } from '../../../config/constants';
import { downloadFile } from '../actions/campaign';


const couponTypeMap = {
  single: 'Single use coupon',
  multiple: 'Bulk use coupon',
};

// eslint-disable-next-line max-lines-per-function
const CouponCard = function CouponCardComponent({
  uuid,
  type,
  totalCodes,
  enabled,
  campaignId,
  onDeleteCoupon,
  onGenerateCodes,
}) {
  const title = couponTypeMap[type] || 'Unknown coupon type';

  const [showModal, setShowModal] = useState(false);
  const [userSelectedQuantity, setUserSelectedQuantity] = useState(0);

  const onModalVisibilityChange = () => {
    if (showModal) {
      setUserSelectedQuantity(0);
    }
    setShowModal(!showModal);
  };

  const onSubmitCodeQuantity = () => {
    onGenerateCodes(userSelectedQuantity, uuid);
    onModalVisibilityChange();
  };

  const getModalActions = () => [
    {
      formActionName: 'Assign',
      onAction: onSubmitCodeQuantity,
      // eslint-disable-next-line react/destructuring-assignment
      ...userSelectedQuantity === 0 && { disabled: 'disabled' },
    },
    {
      formActionName: 'Cancel',
      onAction: onModalVisibilityChange,
    },
  ];

  return (
    <li key={uuid} className="campaign__coupons-card">
      <Accordion
        defaultState={false}
        // eslint-disable-next-line max-lines-per-function
        getShortDescription={() => (
          <div className="campaign__coupon">
            <div className="campaign__coupon-details">
              <div className="campaign__coupon-name">{title}</div>
              <div className="campaign__coupon-details">
                {`${totalCodes} code${totalCodes === '1' ? '' : 's'} available`}
              </div>
            </div>
            <div className="campaign__coupon-controls">
              <Modal
                showModal={showModal}
                onModalVisibilityChange={onModalVisibilityChange}
                modalActions={getModalActions()}
                form={(
                  <GenerateCodes
                    onUpdateQuantity={setUserSelectedQuantity}
                  />
                  )}
              >
                <Tooltip message="Generate Codes">
                  <IconPercent className="campaign__coupon-genetate-codes" />
                </Tooltip>
              </Modal>
              {
                String(totalCodes) !== '0' && (
                  <Tooltip message="Download Codes">
                    <IconDownload
                      className="campaign__coupon-genetate-codes"
                      onClick={(event) => {
                        event.stopPropagation();
                        downloadFile(`/api/coupons/${uuid}/codes/export?campaignId=${campaignId}`, 'file');
                      }}
                    />
                  </Tooltip>
                )
              }
              <Link className="campaign__coupon-edit" to={`/campaigns/coupons/edit/${uuid}/${campaignId}`}>
                <Tooltip message="Edit Coupon">
                  <IconEdit
                    className="campaign__coupon-edit-coupon"
                  />
                </Tooltip>
              </Link>
              <Tooltip message="Delete Coupon">
                <IconTrash
                  className="campaign__coupon-remove-association"
                  onClick={(event) => {
                    event.stopPropagation();
                    onDeleteCoupon(uuid);
                  }}
                />
              </Tooltip>
              <div className="campaign__coupon-state">
                <StatusBadge status={enabled ? 'active' : 'disabled'} size="medium" />
              </div>
            </div>
          </div>
        )}
        getLongDescription={() => (
          <Provider store={CreateResource.getStore('coupons')}>
            <CreateResource
              title=""
              resource="coupons"
              resourceDetails={{
                operation: FORM_OPERATION_READ,
                resourceId: uuid,
                extraParams: {
                  queryParams: `campaignId=${campaignId}&`,
                  bodyParams: {},
                },
              }}
            />
          </Provider>
        )}
      />
    </li>
  );
};

CouponCard.propTypes = {
  uuid: PropType.string.isRequired,
  type: PropType.string.isRequired,
  enabled: PropType.bool.isRequired,
  totalCodes: PropType.string.isRequired,
  campaignId: PropType.string.isRequired,
  onDeleteCoupon: PropType.func.isRequired,
  onGenerateCodes: PropType.func.isRequired,
};

export default CouponCard;
